"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../utils/classFunctions");
require("./index.scss");
const className = 'icon';
class Icon extends react_1.default.PureComponent {
    render() {
        const { name, modificators } = this.props;
        const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
        return (react_1.default.createElement("div", { className: classNames },
            react_1.default.createElement("svg", { className: name, ...this.props },
                react_1.default.createElement("use", { href: `/svg/sprites.svg#${name}` }))));
    }
}
exports.Icon = Icon;
Icon.defaultProps = {
    name: 'phone',
    width: '1em',
    height: '1em',
    shapeRendering: 'auto',
};
//# sourceMappingURL=index.js.map